import React from 'react';
import OfficeFilterDropdown from '@/components/util/OfficeFilterDropdown';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { CampusIcon } from '@v2/icons';

export const ReserveFormOfficeSelector: React.FC = () => {
  const {
    resource,
    selectedOffice,
    offices,
    setSelectedOffice,
    currentOffice,
    setFilterFloor
  } = useReserveForm();

  return (
    <OfficeFilterDropdown
      className="grow"
      readonly={!!resource}
      setOfficeId={(id) => {
        const office = offices.find((x) => x.id === id) ?? currentOffice;
        setSelectedOffice(office);
        setFilterFloor(null);
      }}
      officeId={selectedOffice?.id ?? null}
      offices={offices}
      customIcon={<CampusIcon className="h-4 w-4 opacity-50" />}
    />
  );
};
